import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  cash_registers: [],
};

const getters = {
  allCashRegisters: (state) => state.cash_registers,
};

const actions = {
  async fetchCashRegisters({ commit }, params = {}) {
    try {
      commit("resetCashRegisters");
      const response = await axios.get("/cash-register", { params: prm(params) });
      commit("setCashRegisters", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch cash_registers:", error);
    }
  },
  async fetchOpenCashRegisters({ commit }) {
    try {
      commit("resetCashRegisters");
      const response = await axios.get("/cash-register", { params: { status: "open" } });
      commit("setCashRegisters", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch cash_registers:", error);
    }
  },
  async createCashRegister({ commit }, cash_register) {
    try {
      const response = await axios.post("/cash-register", cash_register);
      commit("addCashRegister", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create cash_register:", error);
      throw error;
    }
  },
  async fetchCashRegisterById(_, id) {
    try {
      const response = await axios.get(`/cash-register/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch cash_register:", error);
      throw error;
    }
  },
  async updateCashRegister({ commit }, cash_register) {
    try {
      const response = await axios.put(`/cash-register/${cash_register.id}`, cash_register);
      commit("updateCashRegister", response.data);
    } catch (error) {
      console.error("Failed to update cash_register:", error);
      throw error;
    }
  },
  async closeCashRegister({ commit }, cash_register) {
    try {
      const response = await axios.post(`/cash-register/close`, cash_register);
      commit("closeCashRegister", response.data);
    } catch (error) {
      console.error("Failed to close cash_register:", error);
      throw error;
    }
  },
  async deleteCashRegisterById({ commit }, id) {
    try {
      const response = await axios.delete(`/cash-register/${id}`);
      commit("removeCashRegister", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete cash_register:", error);
      throw error;
    }
  },
};

const mutations = {
  setCashRegisters(state, cash_registers) {
    state.cash_registers = cash_registers.data; // Ensure this matches your API's response structure
  },
  addCashRegister(state, cash_register) {
    state.cash_registers.push(cash_register);
  },
  updateCashRegister(state, updatedCashRegister) {
    const index = state.cash_registers.findIndex(
      (cash_register) => cash_register.id === updatedCashRegister.id
    );
    if (index !== -1) {
      state.cash_registers.splice(index, 1, updatedCashRegister);
    }
  },
  closeCashRegister(state, updatedCashRegister) {
    const index = state.cash_registers.findIndex(
      (cash_register) => cash_register.id === updatedCashRegister.id
    );
    if (index !== -1) {
      state.cash_registers.splice(index, 1, updatedCashRegister);
    }
  },
  removeCashRegister(state, id) {
    state.cash_registers = state.cash_registers.filter(
      (cash_register) => cash_register.id !== id
    );
  },
  resetCashRegisters(state) {
    state.cash_registers = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
